import { render, staticRenderFns } from "./HistorySleep.vue?vue&type=template&id=67937461&scoped=true&"
import script from "./HistorySleep.vue?vue&type=script&lang=js&"
export * from "./HistorySleep.vue?vue&type=script&lang=js&"
import style0 from "./HistorySleep.vue?vue&type=style&index=0&id=67937461&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67937461",
  null
  
)

export default component.exports